import { jsx as _jsx } from "react/jsx-runtime";
export const CustomMarker = () => {
    return (_jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", style: { position: "relative", left: "-5px", top: "-3px" }, children: _jsx("circle", { cx: "6", cy: "6", r: "5", fill: "white", stroke: "#5732D3", strokeWidth: "2" }) }));
};
